const clearSubmissionItem = function ({ commit }) {
  commit("CLEAR_SUBMISSION");

  return Promise.resolve(undefined);
};

export default clearSubmissionItem;
